<template>
  <div class="imageItem">
    <div class="imgBoxs" v-for="item in imageList" :key="item">
      <img :src="item" class="img" />
      <img
        src="@/assets/image/close3.webp"
        class="close"
        @click="deleteImageList(item)"
      />
    </div>
    <div v-show="loading" class="primary loadingBoxs">
      <el-progress
        type="circle"
        :width="70"
        :percentage="progressPercent"
        define-back-color="#00000070"
        color="#ffffff"
      ></el-progress>
    </div>
    <el-upload
      action=""
      :auto-upload="false"
      accept="image/*"
      :show-file-list="false"
      :on-change="onChange"
      v-show="imageList.length < 9"
    >
      <div class="add">
        <i class="el-icon-upload2"></i>

        点击上传
      </div>
    </el-upload>
  </div>
</template>

<script>
import uploadFile from "@/utils/oss.js"; // 引入oss.js文件
export default {
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  components: {},
  data() {
    return {
      progressPercent: 0,
    };
  },
  created() {},
  computed: {
    loading() {
      return this.progressPercent > 0;
    },
    loadingText() {
      return `上传中 ${this.progressPercent}%`;
    },
    imageList: {
      get() {
        if (!this.value) return [];
        return this.value.split(",");
      },
      set(val) {
        if (val.length === 0) {
          this.onInput("");
        } else {
          this.onInput(val.join(","));
        }
      },
    },
  },
  methods: {
    onProgress(res) {
      console.log(res);
      if (res) {
        this.progressPercent = res;
      }
    },
    onInput(value) {
      this.$emit("input", value);
    },
    pushImageList(val) {
      this.imageList = [...this.imageList, val];
    },
    deleteImageList(val) {
      this.imageList = this.imageList.filter((item) => item !== val);
    },
    async onChange(file) {
      console.log(file);
      try {
        this.onProgress(8);
        const { data } = await this.$api.getFileSts();
        const response = await uploadFile(
          file.raw,
          data,
          "znsign/avatar",
          this.onProgress
        );
        if (response.res.status !== 200) {
          this.$message({
            type: "error",
            message: "上传失败，请联系管理员",
          });
          return;
        }
        this.pushImageList(this.$oss + response.name);
      } catch (error) {
        console.error(error);
      } finally {
        this.progressPercent = 0;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.imageItem {
  display: flex;
  gap: 4px;
  .loadingBoxs {
    width: 98px;
    height: 98px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #00000080;
  }
  .imgBoxs {
    position: relative;
    .img {
      width: 98px;
      height: 98px;
      border-radius: 6px;
      object-fit: cover;
      display: block;
    }
    .close {
      position: absolute;
      width: 16px;
      height: 16px;
      right: 4px;
      top: 4px;
      cursor: pointer;
    }
  }
  .add {
    width: 98px;
    height: 98px;
    background: #f9fbff;
    color: #0062ff;
    box-sizing: border-box;
    border: 1px dashed #dce9fd;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    flex-direction: column;
  }
}
</style>
